import APIService from "../services/APIService";

/**
 * API service for Admin FCC Complaint Cache management.
 * All endpoints require platform_admin role.
 */
const AdminFccCacheAPI = {
  /**
   * Get current FCC cache statistics.
   * Returns: { success, data: { totalRecords, apiSourced, bulkSourced, lastBulkSync, syncInProgress } }
   */
  getCacheStats: async () => {
    try {
      const response = await APIService.get("/api/v1/admin/fcc-cache/stats");
      return response;
    } catch (error) {
      console.error("[AdminFccCacheAPI] Error fetching cache stats:", error);
      throw error;
    }
  },

  /**
   * Trigger an async bulk download of FCC complaint data.
   * @param {boolean} fullDownload - if true, downloads all records; if false, incremental since last sync
   * Returns: { success, message }
   */
  triggerBulkDownload: async (fullDownload = false) => {
    try {
      const response = await APIService.post(
        `/api/v1/admin/fcc-cache/bulk-download?fullDownload=${fullDownload}`,
      );
      return response;
    } catch (error) {
      console.error(
        "[AdminFccCacheAPI] Error triggering bulk download:",
        error,
      );
      throw error;
    }
  },

  /**
   * Purge stale FCC cache entries older than the given number of days.
   * @param {number} olderThanDays - age threshold (default 90)
   * Returns: { success, message, data: { deletedRecords } }
   */
  purgeStaleEntries: async (olderThanDays = 90) => {
    try {
      const response = await APIService.post(
        `/api/v1/admin/fcc-cache/purge?olderThanDays=${olderThanDays}`,
      );
      return response;
    } catch (error) {
      console.error("[AdminFccCacheAPI] Error purging stale entries:", error);
      throw error;
    }
  },
};

export default AdminFccCacheAPI;
